import React from "react";
import Icon from "./Icon";

function SocialLink({ url, label, icon }) {
  return (
    <li>
      <a href={url} className="profile-social__link" aria-label={label}>
        <Icon family="brands" name={icon} />
      </a>
    </li>
  );
}

function SocialLinks({ items }) {
  return (
    <ul className="profile-social" aria-label="Соціальні мережі">
      {items.map((item) => (
        <SocialLink
          key={item.network || item.icon}
          url={item.url}
          label={item.label}
          icon={item.icon}
        />
      ))}
    </ul>
  );
}

export default SocialLinks;
